import React from 'react';
import ProgressBreakdownCell from '../ProgressBreakdownCell/progressBreakdownCell';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';

import './toolUsageProgressCell.scss';


export default function ToolUsageProgressCell(props) {

  let value = props.value;
  // console.log('value ===> ', value);

  let maintenanceData = value?.m_maintenanceData; // All the maintenance type data.

  const progressItems = getProgressItems(maintenanceData);
  const tooltip = getTooltip(maintenanceData);

  return <ProgressBreakdownCell value={{ items: progressItems, tooltip }} />;
}




let getTooltip = (maintenanceData) => {

  if (!maintenanceData) {
    return '';
  }

  if (maintenanceData.type === 'TIME_BASED') {
    return getTooltip__TIME_BASED(maintenanceData.timeBased);
  }

  if (maintenanceData.type === 'USAGE_BASED') {
    return getTooltip__USAGE_BASED(maintenanceData.usageBased);
  }

  if (maintenanceData.type === 'CYCLE_BASED') {
    return getTooltip__CYCLE_BASED(maintenanceData.cycleBased);
  }

  return '';
};


function getProgressItems(maintenanceData) {

  if (!maintenanceData) {
    return [];
  }

  let progressData = extractProgressData(maintenanceData); // Extracted data for progress bar.
  if (!progressData) {
    return [];
  }

  const percentRemaining = progressData.percentRemaining || 0;
  const percentUsed = 100 - percentRemaining;

  const items = [];

  // Add green portion (used)
  if (percentRemaining > 0) {
    items.push({
      width: percentRemaining,
      color: '#5CB85C', // Green color
    });
  }

  // Add gray portion (remaining)
  if (percentUsed > 0) {
    items.push({
      width: percentUsed,
      color: '#D3D3D3', // Gray color
    });
  }

  return items;

}


let extractProgressData = (maintenanceData) => {

  if (!maintenanceData) {
    return null;
  }

  if (maintenanceData.type === 'TIME_BASED' && maintenanceData.timeBased) {
    return {
      percentRemaining: maintenanceData.timeBased.percentRemaining || 0,
    };
  }

  if (maintenanceData.type === 'USAGE_BASED' && maintenanceData.usageBased) {
    return {
      percentRemaining: maintenanceData.usageBased.percentRemaining || 0,
    };
  }

  if (maintenanceData.type === 'CYCLE_BASED' && maintenanceData.cycleBased) {
    return {
      percentRemaining: maintenanceData.cycleBased.percentRemaining || 0,
    };
  }

  return null;
};



function getTooltip__TIME_BASED(timeBasedMaintenanceData) {
  if (!timeBasedMaintenanceData) {
    return '';
  }

  let labels = createLabelHelper('mat.grid.cells.usage.progress.');

  const { remainingMinutes, elapsedMinutes, nextMaintenanceDate } = timeBasedMaintenanceData;

  // Format remaining and elapsed time as Days or Hours
  const remainingFormatted = DateTimeHelper.ConvertMinutesToDaysOrHours(remainingMinutes);
  const elapsedFormatted = DateTimeHelper.ConvertMinutesToDaysOrHours(elapsedMinutes);

  // Format date without time part using standard date formatting
  const nextMaintenanceDateFormatted = nextMaintenanceDate
    ? DateTimeHelper.DateFormat(nextMaintenanceDate)
    : 'N/A';

  return (
    <div className="tool-usage-tooltip" style={{ padding: '8px' }}>

      <span className="label-time-based">{labels.get('remaining')}:</span>
      <span>{remainingFormatted}</span>

      <span className="label-time-based">{labels.get('elapsed_since_maintenance')}:</span>
      <span>{elapsedFormatted}</span>

      <span className="label-time-based">{labels.get('next_maintenance_due')}:</span>
      <span>{nextMaintenanceDateFormatted}</span>

    </div>
  );

}


function getTooltip__USAGE_BASED(usageBasedMaintenanceData) {
  if (!usageBasedMaintenanceData) {
    return '';
  }

  let labels = createLabelHelper('mat.grid.cells.usage.progress.');

  const { remainingMinutes, completedMinutes, startedMinutes, scheduledMinutes } = usageBasedMaintenanceData;

  // Format all times in Hours only (not Days)
  const remainingFormatted = DateTimeHelper.ConvertMinutesToHours(remainingMinutes);
  const completedFormatted = DateTimeHelper.ConvertMinutesToHours(completedMinutes);
  const inProgressFormatted = DateTimeHelper.ConvertMinutesToHours(startedMinutes);
  const scheduledFormatted = DateTimeHelper.ConvertMinutesToHours(scheduledMinutes);

  return (
    <div className="tool-usage-tooltip" style={{ padding: '8px' }}>

      <span className="label-usage-based">{labels.get('remaining')}:</span>
      <span>{remainingFormatted}</span>

      <span className="label-usage-based">{labels.get('completed')}:</span>
      <span>{completedFormatted}</span>

      <span className="label-usage-based">{labels.get('in_progress')}:</span>
      <span>{inProgressFormatted}</span>

      <span className="label-usage-based">{labels.get('scheduled')}:</span>
      <span>{scheduledFormatted}</span>

    </div>
  );

}


function getTooltip__CYCLE_BASED(cycleBasedMaintenanceData) {
  if (!cycleBasedMaintenanceData) {
    return '';
  }

  let labels = createLabelHelper('mat.grid.cells.usage.progress.');
  let dicLabels = createLabelHelper('dic.');
  let L = {
    cycles: dicLabels.get('cycle.pascals'),
  };

  const { remainingCycles, completedCycles, startedCycles, scheduledCycles } = cycleBasedMaintenanceData;

  // Format cycle counts as "X cycles"
  const remainingFormatted = `${remainingCycles || 0} ${L.cycles}`;
  const completedFormatted = `${completedCycles || 0} ${L.cycles}`;
  const inProgressFormatted = `${startedCycles || 0} ${L.cycles}`;
  const scheduledFormatted = `${scheduledCycles || 0} ${L.cycles}`;

  return (
    <div className="tool-usage-tooltip" style={{ padding: '8px' }}>

      <span className="label-cycle-based">{labels.get('remaining')}:</span>
      <span>{remainingFormatted}</span>

      <span className="label-cycle-based">{labels.get('completed')}:</span>
      <span>{completedFormatted}</span>

      <span className="label-cycle-based">{labels.get('in_progress')}:</span>
      <span>{inProgressFormatted}</span>

      <span className="label-cycle-based">{labels.get('scheduled')}:</span>
      <span>{scheduledFormatted}</span>

    </div>
  );

}
